/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./video-container.vue?vue&type=template&id=11dd776a&scoped=true&"
import script from "./video-container.vue?vue&type=script&lang=js&"
export * from "./video-container.vue?vue&type=script&lang=js&"
import style0 from "./video-container.vue?vue&type=style&index=0&id=11dd776a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd776a",
  null
  
)

export default component.exports